import React from 'react';
import ReactDOM from 'react-dom';
import ShortenerPage from './ShortenerPage';

ReactDOM.render(<ShortenerPage />, document.getElementById('root'));
